<script setup>
    definePageMeta({
        layout: 'iframe',
    })

    // Builder.io
    import { Content, isPreviewing } from '@builder.io/sdk-vue'
    // Internal
    import { getComponents } from '@/composables/builder/blocks'
    import { getBuilderContent } from '@/composables/builder/content'
    import { getSeoOptions } from '@/composables/data/cacSeo'
    import { getModelFromURL } from '@/composables/builder/model'
    import { useGlobalStore } from '@/stores/global'

    const { $config } = useNuxtApp()
    const { urlExceptions } = useGlobalStore() || {}

    const route = useRoute()

    const model_options = getModelFromURL(route.path, 'page', $config, urlExceptions)
    const model = model_options.model ? model_options.model : 'page'
    const options = model_options.options
    const can_show_content = ref(isPreviewing(route.fullPath))

    const { content, api_key, error } = await getBuilderContent()

    if (error.statusCode === 500) { throw error }

    if (!isPreviewing(route.fullPath)) {
        if (error) { throw error }
        if (content.value?.data) {
            const seoOptions = getSeoOptions(content.value, model)
            if (content.value.data?.seo?.seo?.removeTitleTail) {
                useHead({
                    titleTemplate: '%s'
                })
            }
            if ( seoOptions.title ) {
                useSeoMeta({
                    title: seoOptions.title,
                    ogTitle: seoOptions.title,
                    description: seoOptions.description,
                    ogDescription: seoOptions.description,
                    ogImage: seoOptions.webpage.image,
                    twitterCard: 'summary_large_image',
                })
            }
        }
        can_show_content.value = content ? true : isPreviewing(route.fullPath)
    }

    const editorUpdate = (event) => {
        const { data } = event.data
        const new_content = { ...content.value }
        new_content.data = { ...new_content.data, ...data.data.data }
        content.value = new_content
        can_show_content.value = true
    }

    const builderMessage = (event) => {
        if (event.data?.type !== 'builder.contentUpdate') return
        editorUpdate(event)
    }

    onMounted(() => {
        if (isPreviewing(route.fullPath)) {
            window.addEventListener('message', builderMessage, '*')
        }
    })

    onBeforeUnmount(() => {
        if (isPreviewing(route.fullPath)) {
            window.removeEventListener('message', builderMessage)
        }
    })

</script>

<template>
    <div>
        <div v-if="model && can_show_content" class="page-wrapper">
            <template v-if="can_show_content && content">
                <TeamMemberDetailHeader v-if="model ==='team-members'" :member="content.data" />
                <CityToursHeader v-if="model === 'tours'" :content="content" />
                <CityToursDetails v-if="model === 'tours'" :tour="content" />
                <ProgramDetailHeader v-if="model === 'programs-events'" :page="content" />
                <EncyclopediaArticleDetailHeader v-if="model === 'architecture-encyclopedia-articles'" :article="content" />
                <ExhibitionHero v-if="model === 'exhibitions'" :exhibition="content" />
                <BuildingsHeader v-if="model === 'buildings'" :page="content" />
                <BuildingsDetail v-if="model === 'buildings'" :building="content.data" />
            </template>
            <main id="main" key="page" class="mess-page page.vue" tabindex="-1">
                <Content
                    :api-key="api_key"
                    :model="model"
                    :content="content"
                    :customComponents="getComponents(api_key)" />
            </main>
        </div>
    </div>
</template>

<style lang="scss">
.cky-btn-revisit-wrapper,
.cky-consent-container {
    display: none !important;
}
</style>